<script setup lang="ts">
const model = defineModel<'snippet' | 'table'>({ required: true })
</script>

<template>
  <div
    role="group"
    class="ml-auto flex shrink-0 items-center gap-3"
  >
    <button
      type="button"
      class="flex h-8 w-5 items-center justify-center"
      :aria-pressed="model === 'snippet'"
      :class="model === 'snippet' ? 'text-textColor' : 'text-textSecondary'"
      @click="model = 'snippet'"
    >
      <svg-icon
        name="icon-grid-one"
        width="20"
        height="20"
        aria-hidden="true"
      />
    </button>
    <button
      type="button"
      class="flex h-8 w-5 items-center justify-center"
      :aria-pressed="model === 'table'"
      :class="model === 'table' ? 'text-textColor' : 'text-textSecondary'"
      @click="model = 'table'"
    >
      <svg-icon
        name="icon-catalog-table"
        width="20"
        height="20"
        aria-hidden="true"
      />
    </button>
  </div>
</template>
